export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11524.3db31a64.jpg";